export default "__VITE_ASSET__Cs5b$TCw__"